var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLeftArrow({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "mingcute:left-fill",
    clipPath: "url(#clip0_320_942)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.94002 13.0599C7.65912 12.7787 7.50134 12.3974 7.50134 11.9999C7.50134 11.6024 7.65912 11.2212 7.94002 10.9399L13.596 5.2819C13.8774 5.00064 14.259 4.84268 14.6569 4.84277C14.8539 4.84282 15.0489 4.88167 15.2309 4.9571C15.4129 5.03253 15.5783 5.14307 15.7175 5.2824C15.8568 5.42173 15.9672 5.58713 16.0426 5.76915C16.1179 5.95117 16.1567 6.14625 16.1567 6.34325C16.1566 6.54025 16.1178 6.73531 16.0423 6.9173C15.9669 7.09929 15.8564 7.26463 15.717 7.4039L11.122 11.9999L15.718 16.5959C15.8614 16.7342 15.9757 16.8997 16.0544 17.0826C16.1331 17.2656 16.1746 17.4624 16.1764 17.6616C16.1782 17.8607 16.1404 18.0583 16.065 18.2427C15.9897 18.427 15.8784 18.5946 15.7376 18.7355C15.5968 18.8764 15.4294 18.9878 15.2451 19.0633C15.0608 19.1389 14.8633 19.1769 14.6641 19.1753C14.465 19.1736 14.2681 19.1323 14.0851 19.0538C13.902 18.9753 13.7365 18.8611 13.598 18.7179L7.93802 13.0599H7.94002Z",
    fill: "#C3645E"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_320_942"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLeftArrow);
export default __webpack_public_path__ + "static/media/left-arrow.fcfa9a476b43d61e62975ab222d4d5eb.svg";
export { ForwardRef as ReactComponent };